import "babel-polyfill";
import "typeface-roboto";
import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/browser";
import { concat } from "apollo-link";
import { HttpLink } from "apollo-link-http";
import { ApolloProvider } from "react-apollo";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { onError } from "apollo-link-error";
import { setContext } from "apollo-link-context";
import "react-toastify/dist/ReactToastify.css";
import "./styles/react-toastify.css";
import "./react-table-defaults";
import "./styles/index.css";
import JssProvider from "react-jss/lib/JssProvider";
import { create } from "jss";
import { createGenerateClassName, jssPreset } from "@material-ui/core/styles";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import jssExtend from "jss-extend";
import store from "store";
import { ToastContainer } from "react-toastify";
import { routes } from "./fuse-configs/fuseRoutesConfig";
import { FuseLayout, FuseTheme } from "@fuse";
import MainToolbar from "./main/MainToolbar";
import MainNavbarContent from "./main/MainNavbarContent";
import MainNavbarHeader from "./main/MainNavbarHeader";
import { apiBaseUrl, SENTRY_DSN } from "./config";

import history from "./history";
import { getLoginToken } from "./utils";

Sentry.init({
  dsn: SENTRY_DSN
});

const jss = create({
  ...jssPreset(),
  plugins: [...jssPreset().plugins, jssExtend()]
});

jss.options.insertionPoint = document.getElementById("jss-insertion-point");
const generateClassName = createGenerateClassName();

// Create an http link:
const rawHttpLink = new HttpLink({
  uri: `${apiBaseUrl}/graphql`
});

const authLink = setContext(async () => {
  const token = getLoginToken();
  return {
    headers: {
      authorization: token ? `Bearer ${token}` : ""
    }
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  }
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

// rawHttpLink need to be last
const combineHttpLink = concat(concat(authLink, errorLink), rawHttpLink);

// Finally, create your ApolloClient instance with the modified network interface
const apolloClient = new ApolloClient({
  link: combineHttpLink,
  cache: new InMemoryCache()
});

ReactDOM.render(
  <ApolloProvider client={apolloClient}>
    <JssProvider jss={jss} generateClassName={generateClassName}>
      <Provider store={store}>
        <Router history={history}>
          <FuseTheme>
            <ToastContainer />
            <FuseLayout
              routes={routes}
              toolbar={<MainToolbar />}
              navbarHeader={<MainNavbarHeader />}
              navbarContent={<MainNavbarContent />}
              contentWrapper={null}
            />
          </FuseTheme>
        </Router>
      </Provider>
    </JssProvider>
  </ApolloProvider>,
  document.getElementById("root")
);

// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js